import CardSide from './CardSide';

export default CardSide;
